import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import Image from "components/elements/image"
import { ImageFields } from "components/sections/homeHeroV2/props"
import PropTypes from "prop-types"
import React from "react"
import Helpers from "utils/helpers"
import "./page-hero-v2.scss"

const PageHeroV2 = ({
  pageHeroCallsToActions,
  pageHeroIcons,
  pageHeroImage,
  text,
  title,
}) => {
  return (
    <section className="page-hero-v2">
      <div className="container-v2">
        <div className="page-hero-v2--content">
          <div className="page-hero-v2--content-header">
            {title && (
              <h1
                className="page-hero-v2--content-header-title"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            {text?.childrenMarkdownRemark &&
              text.childrenMarkdownRemark.length > 0 &&
              text.childrenMarkdownRemark.map((item, index) => (
                <div
                  className="page-hero-v2--content-text"
                  dangerouslySetInnerHTML={{
                    __html: item.html,
                  }}
                  key={index}
                />
              ))}

            {pageHeroCallsToActions && pageHeroCallsToActions.length > 0 && (
              <div className="page-hero-v2--content-buttons">
                {pageHeroCallsToActions.map(action => (
                  <p className="page-hero-v2--content-button" key={action.id}>
                    <ButtonV2
                      accessibilityLabel={action.accessibilityLabel}
                      className={getButtonClasses(
                        action.buttonStyle || "primary-green",
                        action.buttonSize || "large"
                      )}
                      href={action.path}
                      key={action.id}
                      showArrow={action.showArrow === "Yes" ? true : false}
                      text={action.text}
                    />
                  </p>
                ))}
              </div>
            )}
          </div>

          <div className="page-hero-v2--content-image-wrapper">
            {pageHeroImage?.fluid && (
              <Image alt={pageHeroImage.title} image={pageHeroImage.fluid} />
            )}

            {pageHeroIcons && pageHeroIcons.length > 0 && (
              <div className="page-hero-v2--content-icons">
                {pageHeroIcons.map(item => (
                  <div
                    className={`page-hero-v2--content-icon-wrapper page-hero-v2--content-icon-wrapper--${Helpers.normalizePosition(
                      item.position
                    )}`}
                    key={item.id}
                  >
                    <img alt={item?.title} src={item?.icon?.file?.url} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

PageHeroV2.propTypes = {
  pageHeroCallsToActions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      path: PropTypes.string,
    })
  ),
  pageHeroIcons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      position: PropTypes.string,
      title: PropTypes.string,
      icon: PropTypes.shape({
        ...ImageFields,
      }),
    })
  ),
  pageHeroImage: PropTypes.shape({
    ...ImageFields,
    fluid: PropTypes.shape({
      src: PropTypes.string,
      srcSet: PropTypes.string,
      srcWebp: PropTypes.string,
      srcSetWebp: PropTypes.string,
      sizes: PropTypes.string,
      aspectRatio: PropTypes.number,
      base64: PropTypes.string,
    }),
    title: PropTypes.string,
  }),
  text: PropTypes.shape({
    childrenMarkdownRemark: PropTypes.arrayOf(
      PropTypes.shape({
        html: PropTypes.string,
      })
    ),
  }),
  title: PropTypes.string.isRequired,
}

export default PageHeroV2
